import { useLocation } from 'react-router-dom';

// The three admin contexts share pages; links must keep the viewer inside
// their own context (see CLAUDE.md: context-aware routing).
export const getAdminRouteContext = (pathname = '') => {
  const isTrackAdmin = pathname.includes('admin-track');
  const isEmployeeAdmin = pathname.includes('admin-employee');

  let routePrefix = '/admin';
  if (isTrackAdmin) routePrefix = '/admin-track';
  if (isEmployeeAdmin) routePrefix = '/admin-employee';

  return {
    isTrackAdmin,
    isEmployeeAdmin,
    isScopedAdmin: isTrackAdmin || isEmployeeAdmin,
    routePrefix,
  };
};

const useAdminRouteContext = () => {
  const { pathname } = useLocation();
  return getAdminRouteContext(pathname);
};

export default useAdminRouteContext;
